import { render, staticRenderFns } from "./AddressMap.vue?vue&type=template&id=2defdc99&scoped=true&"
import script from "./AddressMap.vue?vue&type=script&lang=js&"
export * from "./AddressMap.vue?vue&type=script&lang=js&"
import style0 from "./AddressMap.vue?vue&type=style&index=0&id=2defdc99&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2defdc99",
  null
  
)

export default component.exports